export class FindAllDefaultRolesError {
  public static readonly type =
    '[Project/ProjectRoles/List] FindAllDefaultRolesError';
  constructor(public readonly error: Error) {}
}
